export default __webpack_public_path__ + "static/media/gummy.c4cbb06f.png";